import { render, staticRenderFns } from "./suporte-salas-roboticas.vue?vue&type=template&id=4f480a76"
import script from "./suporte-salas-roboticas.vue?vue&type=script&lang=ts"
export * from "./suporte-salas-roboticas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports